var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.imageMarkerList),function(item){return _c('div',{key:'imageMarker'+item.mainId},[_c('image-marker',{attrs:{"imageMarkerInfo":item},on:{"clickImageMarker":_vm.clickImageMarker}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }